<template>
  <div class="cabinet">
    <v-layout v-if="data.template" column class="wrapper" ma-0 pa-0>
      <div :style="`width: ${cabinet.width}px; height: ${cabinet.height_top}px; backgroundColor: #464646;`">
        <v-layout fill-height justify-space-between align-center px-2>
          <span class="uppercase white--text" :style="`transform: scale(2); transform-origin: left;`">{{$t('front')}}</span>
          <span class="uppercase white--text" :style="`transform: scale(2); transform-origin: right;`">{{$t('rear')}}</span>
        </v-layout>
      </div>
      <v-layout v-if="cabinet.unit" v-for="(position, index) in getUnitPosition" :key="index" ma-0 px-0>
        <div
          v-if="cabinet.unit[position].open"
          :id="position"
          class="unit text-xs-center display-1"
          :style="`width: ${cabinet.width}px;`"
        >
          <v-layout fill-height justify-center align-center>
            <v-btn :data-testid="$options.name + 'v-btn' + 'onSelect-positionfront'" block flat v-if="$store.state.auth.user.level <= 1" 
              @click.stop="() => onSelect(position, 'front')" 
              class="plus font-weight-medium"
              :style="`backgroundColor: ${selectedSlots.some(slot => slot == position) && selectedSlotsSide == 'front' ? '#a7c9fa' : ''};`"
            >
              <v-icon x-large left class="plus">
                add_circle
              </v-icon>
            </v-btn>

            <v-btn :data-testid="$options.name + 'v-btn' + 'onSelect-positionrear'" block flat v-if="$store.state.auth.user.level <= 1" 
              @click.stop="() => onSelect(position, 'rear')" 
              class="plus font-weight-medium" 
              :style="`backgroundColor: ${selectedSlots.some(slot => slot == position) && selectedSlotsSide == 'rear' ? '#a7c9fa' : ''};`"
            >
              <v-icon x-large right class="plus">
                add_circle
              </v-icon>
            </v-btn>
          </v-layout>
        </div>

        <div
          v-if="!cabinet.unit[position].open"
          :id="position"
          class="unit text-xs-center display-1"
          :style="`width: ${cabinet.width}px;`"
          @click.stop=""
        >
          <v-layout fill-height ma-0 px-5
            justify-space-between
          >
            <div
              v-if="cabinet.unit[position].device[0]"
              :style="`width: ${cabinet.width / cabinet.depth * cabinet.unit[position].device[0].depth}px; height: 45px; background-color: ${$getColor(getStatuses[cabinet.unit[position].device[0].$id])};`"
              @click.stop="() => onSelect(cabinet.unit[position].device[0])"
              :class= "(getSelected && getSelected.$id == cabinet.unit[position].device[0].$id) ? 'active' : ''"
            >
            </div>

            <div
              v-if="!cabinet.unit[position].device[1] && cabinet.width - (cabinet.width / cabinet.depth * cabinet.unit[position].device[0].depth) > 10"
              :style="`width: ${cabinet.width - (cabinet.width / cabinet.depth * cabinet.unit[position].device[0].depth)}px; height: 45px;`"
            >
              <v-layout fill-height justify-center align-center>
                <v-btn :data-testid="$options.name + 'v-btn' + 'onSelect-positionrear'" block flat v-if="$store.state.auth.user.level <= 1" 
                  @click.stop="() => onSelect(position, 'rear')" 
                  class="plus font-weight-medium" 
                  :style="`backgroundColor: ${selectedSlots.some(slot => slot == position) && selectedSlotsSide == 'rear' ? '#a7c9fa' : ''};`"
                >
                  <v-icon x-large class="plus">
                    add_circle
                  </v-icon>
                </v-btn>
              </v-layout>
            </div>

            <div
              v-if="!cabinet.unit[position].device[0] && cabinet.width - (cabinet.width / cabinet.depth * cabinet.unit[position].device[1].depth) > 10"
              :style="`width: ${cabinet.width - (cabinet.width / cabinet.depth * cabinet.unit[position].device[1].depth)}px; height: 45px;`"
            >
              <v-layout fill-height justify-center align-center>
                <v-btn :data-testid="$options.name + 'v-btn' + 'onSelect-positionfront'" block flat v-if="$store.state.auth.user.level <= 1" 
                  @click.stop="() => onSelect(position, 'front')" 
                  class="plus font-weight-medium"
                  :style="`backgroundColor: ${selectedSlots.some(slot => slot == position) && selectedSlotsSide == 'front' ? '#a7c9fa' : ''};`"
                >
                  <v-icon x-large class="plus">
                    add_circle
                  </v-icon>
                </v-btn>
              </v-layout>
            </div>

            <div
              v-if="cabinet.unit[position].device[1]"
              :style="`width: ${cabinet.width / cabinet.depth * cabinet.unit[position].device[1].depth}px; height: 45px;  background-color: ${$getColor(getStatuses[cabinet.unit[position].device[1].$id])};`"
              @click.stop="() => onSelect(cabinet.unit[position].device[1])"
              :class= "(getSelected && getSelected.$id == cabinet.unit[position].device[1].$id) ? 'active' : ''"
            >
            </div>
          </v-layout>
        </div>

        <div class="headline test-xs-center unit-positions">
          {{position}}
        </div>
      </v-layout>
      <div :style="`width: ${cabinet.width}px; height: ${cabinet.height_bottom}px; backgroundColor: #464646;`"></div>
    </v-layout>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

// Типы
interface DeviceItem {
  $id?: string
  id?: string
  cls?: string
  name?: string
  template?: string
  height?: number
  position?: number
  width?: number
  mount?: string
  [key: string]: any
}

interface CabinetTemplate {
  top: string | null
  bottom: string | null
  main: string | null
}

interface UnitDevice {
  [key: number]: DeviceItem | undefined
}

interface UnitItem {
  id: number
  open: boolean
  unit: any | null
  device: UnitDevice
}

interface CabinetUnit {
  [key: number]: UnitItem
}

interface CabinetData {
  $id?: string
  id?: string
  cls?: string
  name?: string
  template?: string
  usize?: number
  width?: number
  depth?: number
  height_top?: number
  height_bottom?: number
  children?: DeviceItem[]
  [key: string]: any
}

interface ClosedUnit {
  position: number
  device: DeviceItem[]
}

interface CabinetState {
  template: CabinetTemplate
  devices: DeviceItem[]
  closed: ClosedUnit[]
  size: number | null
  side: string
  width: number
  depth: number
  height_top: number
  height_bottom: number
  unit: CabinetUnit
}

interface StatusesMap {
  [key: string]: string
}

interface SelectedSlot {
  [key: string]: any
}

export default Vue.extend({
  name: 'CABINET_SIDE',

  components: {},

  props: {
    mount: {
      type: String,
      default: undefined
    },
    data: {
      type: Object as () => CabinetData,
      default: () => ({})
    },
    selectedSlot: {
      type: Object as () => SelectedSlot,
      default: () => ({})
    },
    selectedSlotsSide: {
      type: String,
      default: () => 'front'
    },
    selectedSlots: {
      type: Array as () => any[],
      default: () => []
    },
  },

  data(): {
    cabinet: CabinetState
    statuses: StatusesMap
  } {
    return {
      cabinet: {
        template: {
          top: null,
          bottom: null,
          main: null
        },
        devices: [],
        closed: [],
        size: null,
        side: '',
        width: 1000,
        depth: 800,
        height_top: 60,
        height_bottom: 68,
        unit: {},
      },
      statuses: {},
    }
  },

  computed: {
    getDevices(): DeviceItem[] | undefined {
      if (!this.data) return undefined
      return this.cabinet.devices
    },

    getUnitPosition(): number[] {
      return Object.keys(this.cabinet.unit).map(Number).slice().reverse()
    },

    getData(): CabinetData {
      return this.data
    },

    getSelected(): any {
      return this.$store.state.devices.activeDevice
    },

    getStatuses(): StatusesMap {
      return this.statuses
    },
  },

  watch: {
    data: {
      handler(newVal: CabinetData): void {
        if (!newVal || !newVal.$id) return
        this.setup('watch data')
      },
      deep: true
    },
    '$store.state.devices.treeActive': {
      handler(): void {
        this.setup()
      },
      deep: true
    },
  },

  created(): void {
    this.$set(this.cabinet.template, 'top', this.getBackground(this.data.template, 'top'))
    this.$set(this.cabinet.template, 'bottom', this.getBackground(this.data.template, 'bottom'))
    this.$set(this.cabinet.template, 'unit', this.getBackground(this.data.template, 'unit'))
    
    if (this.data.$id) {
      this.setup('created')
    }
  },

  beforeDestroy(): void {
    this.statusUnsubscribe()
  },

  methods: {
    setup(caller?: string): void {
      this.statusUnsubscribe()

      this.$set(this.cabinet, 'size', this.getData.usize || 42)
      this.$set(this.cabinet, 'side', this.mount || 'side')
      this.$set(this.cabinet, 'width', this.getData.width || 1000)
      this.$set(this.cabinet, 'depth', this.getData.depth || 800)
      this.$set(this.cabinet, 'height_top', this.getData.height_top || 60)
      this.$set(this.cabinet, 'height_bottom', this.getData.height_bottom || 68)

      if (this.data.children) {
        this.$set(this.cabinet, 'devices', [])
        this.data.children.forEach((device: DeviceItem) => {
          this.cabinet.devices.push(device)
        })
      }
      this.createUnits()
      this.addUnitStatus()
    },

    createUnits(): void {
      this.cabinet.unit = {}
      const size = this.cabinet.size || 0
      
      for (let i = 0; i < size; i++) {
        this.cabinet.unit[i + 1] = {
          id: i + 1,
          open: true,
          unit: null,
          device: {}
        }
      }
    },

    addUnitStatus(): void {
      this.$set(this.cabinet, 'closed', [])
      
      this.cabinet.devices.forEach((device: DeviceItem) => {
        const deviceHeight = device.height || 0
        const position = device.position || 0
        const mount = device.mount
        
        if (deviceHeight > 45) {
          const count = Math.ceil(deviceHeight / 45)
          
          for (let i = position; i > position - count; i--) {
            if (!this.cabinet.unit[i]) continue
            
            this.cabinet.unit[i].open = false
            
            if (mount === 'rear') {
              this.cabinet.unit[i].device[1] = device
            } else {
              this.cabinet.unit[i].device[0] = device
            }
            
            const existingClosed = this.cabinet.closed.find(u => u.position === i)
            if (existingClosed) {
              existingClosed.device.push(device)
            } else {
              this.cabinet.closed.push({
                position: i,
                device: [device]
              })
            }
          }
        } else {
          if (!this.cabinet.unit[position]) return
          
          this.cabinet.unit[position].open = false
          
          if (mount === 'rear') {
            this.cabinet.unit[position].device[1] = device
          } else {
            this.cabinet.unit[position].device[0] = device
          }
          
          const existingClosed = this.cabinet.closed.find(u => u.position == position)
          if (existingClosed) {
            existingClosed.device.push(device)
          } else {
            this.cabinet.closed.push({
              position: position,
              device: [device]
            })
          }
        }
      })
    },

    checkPosition(position: number): DeviceItem[] {
      const devices = this.getDevices?.filter(device => {
        return device.position && device.position == position
      }) || []
      return devices
    },

    onSelect(payload: any, side?: string): void {
      if (typeof payload === 'object') {
        this.$emit('select', payload)
      } else {
        const unit = {
          cls: 'unit',
          position: payload,
          side: side || this.cabinet.side,
          closed: this.cabinet.closed,
          cabinet: {
            obj: this.getData,
            name: this.getData.name,
            cls: this.getData.cls,
            id: this.getData.id,
            usize: this.getData.usize,
          }
        }
        this.$emit('select', unit)
      }
    },

    async getBackground(data: string | undefined, side: string): Promise<string | undefined> {
      if (!data) return undefined
      const path = await this.$bridge.getImageLinkByTemplate('cabinet', data, side)
      if (path) {
        return path.replace(/\s/g, '%20')
      }
      return undefined
    },

    async statusSubscribe(): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        handler: this.subscribeHandler,
        group: 'cabinet',
        listener: 'status'
      })
      
      if (this.cabinet.devices?.length) {
        await this.$bridge.subscribe(this.cabinet.devices.map(device => device.$id))
      }
    },

    subscribeHandler(e: { $id?: string; state?: { infoState?: string }; [key: string]: any }): void {
      if (e.$id) {
        const status = e.state?.infoState || 'unknown'
        this.$set(this.statuses, e.$id, status)
      }
    },

    statusUnsubscribe(): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: 'cabinet',
        listener: 'status'
      })
    },
  },
})
</script>

<style scoped>

.cabinet {
  /* height: 44.5px;
  width: 603px; */
  height: 100%;
  width: 100%;
  /* transform-origin: 0 0; */
  /* transform: scale(.45); */
  /* left: 28px; */
  /* top: 28px; */
  cursor: pointer;
  /* padding: 14px 0px 20px 6px; */
  position: relative;
  /* position: absolute; */
}

.active {
  outline: solid 2px orange;
  /* border: solid 1px orange; */
}

.wrapper {
  /* height: 44.5px;
  width: 603px; */
  /* height: 100%;
  width: 100%; */
  transform-origin: 0 0;
  transform: scale(.4);
  /* transform: scale(.34); */
  /* left: 28px;
  top: 28px; */
  /* cursor: pointer; */
  /* padding: 14px 0px 20px 6px; */
  /* position: relative; */
  position: absolute;
}

.unit {
  height: 45px;
  /* width: 603px; */
  /* background-size: contain; */
  /* height: 44.5px;
  width: 450px; */
  /* background-color: white; */
  /* box-sizing: border-box; */
  border: solid 1px grey;
  cursor: pointer;
  /* background-image: url(template/unit_.png); */
  /* transform-origin: 0 0; */
  /* transform: scale(.45); */
  /* display: none; */
  /* border: solid 1px grey; */
  /* position: relative; */
  /* color: #fff; */
  /* color: transparent; */
  /* padding: 1px 1px 1px 1px; */
}


.unit-positions {
  /* width: 80px; */
  display: flex;
  justify-content: flex-end;
  /* height:900px; */
  padding: 6px 0px 0px 8px;

  /* position: relative; */
  /* background-color: white; */
  /* border: solid 1px grey */
}
/* .unit:hover {
  height: 44.5px;
  width: 450px;
  background-color: #F7941D;
  box-sizing: border-box;
  border: solid 1px grey;
  position: relative;

} */

.plus {
  color: #fafafa;
}

.plus:hover {
  color: green;
}

/* .open:hover {
  color: white;
} */

.open {
  background-color: white;
  height: 45px;
  /* width: 490px; */
  width: 450px;
  box-sizing: border-box;
  border: solid 1px grey;
}

.open:hover {

  background-color: #F7941D;

}

.open:hover::after {

  /* content: 'Добавить устройство'; */
  content: '+';
  color: #fff;

}

.closed {
  background-color: transparent;
  /* height: 45px;
  width: 450px; */
  /* width: 490px; */
  /* width: 450px; */
}

</style>
